module.exports = __webpack_public_path__ + "img/wave2.3088b7af.svg";